import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {makeStyles} from "@material-ui/core/styles";
import {Link, useHistory} from "react-router-dom";
import ChatContainer from "../../Components/ChatContainer";
import VetAppointmentView from "../../Components/VetAppointmentView";
import {useLocation} from "react-router";

const useStyle = makeStyles(() => ({
}));
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
const ChatRoom = () => {
    const history = useHistory();
    const query = useQuery();
    const isJoin = query.get("isJoin");
    if (window.location.search.includes("isJoin")) {window.history.replaceState({}, document.title, "/" + "chat");}
    const user = useSelector((state: RootState) => state?.user);
    const data = useSelector((state: RootState) => state?.chat.chatData);
    const [videoChatIsClosed, setVideoChatIsClosed] = useState<null | string>(null);
    const [chatData, setChatData] = useState(data);
    const [isModalVisible, setModalVisibility] = useState(false);
    const handleCloseTranscript = () => {
        history.push("/appointments");
        setChatData({});
    };
    const handleChatData = (open, data, over) => {
        if (open) {
            setChatData({data, over});
        } else {
            history.push("/appointments");
            setChatData({});
        }
    };
    return (
        <div>
            {(user.role === "OWNER") ?
                <>
                    <ChatContainer data={chatData} over={chatData?.over} close={isModalVisible}
                        handleChatData={handleChatData} isJoin={isJoin}
                        setVideoChatIsClosed={setVideoChatIsClosed}
                        videoChatIsClosed={videoChatIsClosed}
                    />
                </>
                :
                chatData?.over ? (
                    <ChatContainer data={chatData} over={chatData?.over} close={isModalVisible}
                        handleChatData={handleChatData} handleCloseTranscript={handleCloseTranscript}
                        isTranscript={true} isJoin={isJoin}
                        setVideoChatIsClosed={setVideoChatIsClosed}
                        videoChatIsClosed={videoChatIsClosed}
                    />
                ) : (
                    user.role === "VET" &&
                    <VetAppointmentView data={chatData} over={chatData?.over} close={isModalVisible}
                        handleChatData={handleChatData}
                        handleCloseTranscript={handleCloseTranscript} isJoin={isJoin}
                        setVideoChatIsClosed={setVideoChatIsClosed}
                        videoChatIsClosed={videoChatIsClosed}
                    />
                )
            }
        </div>
    );
};

export default ChatRoom;
